export default {"src":"/_next/static/media/trustpilot_half_star_black.b03f37ee.svg","height":15,"width":14};